<template>
  <q-page class="window-height window-width row justify-center items-center">
    <div class="column">
      <div class="row">
        <q-form @submit.prevent="login" ref="formLogin">
          <q-card square bordered class="q-pa-lg shadow-1">
            <img alt="Super Simples logo" src="@/assets/logo.jpg">
            <div class="row justify-center">
              <h5 class="text-h5 q-my-md">Login</h5>
            </div>
            <q-card-section class="q-gutter-md">
              <q-input 
                square 
                filled 
                v-model="auth.email" 
                type="email" 
                label="Email"
                color="green-10"
                :rules="[
                  val => isValidMail(val) || 'Digite um email válido'
                ]"
              />
              <q-input 
                square 
                filled 
                v-model="auth.senha" 
                type="password" 
                label="Senha"
                color="green-10"
                :rules="[
                  val => val && val.length || 'Digite a senha'
                ]"
              />
            </q-card-section>
            <q-card-actions class="q-px-md">
              <q-btn unelevated color="green-10" type="submit" size="lg" class="full-width" label="Login" />
            </q-card-actions>
            <q-card-section class="text-center q-pa-none">
              <p class="text-grey-6">
                <a href="#/resetPassword">Esqeci minha senha</a>
              </p>
            </q-card-section>
          </q-card>
        </q-form>
      </div>
    </div>
  </q-page>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import { login } from '../services/usuario'

export default {
  data: () => {
    return {
      auth: {
        email: '',
        senha: ''
      },
      loading: false
    }
  },
  // beforeCreate () {
  //   if (this.$store.getters.getToken) {
  //     this.$router.push({ name: 'Main' })
  //   }
  // },
  mounted () {
    if (this.usuarioLogado.email) {
      this.auth.email = this.usuarioLogado.email
    }
    if (this.message) {
      this.$bvToast.toast(this.message, {
        title: 'SRCAL',
        variant: 'success',
        solid: true
      })
      this.$store.dispatch('setMessage', '')
    }
  },
  methods: {
    async login () {
      try {
        this.loading = true
        const token = await login(this.auth)
        this.$store.dispatch('setToken', token)
        if (this.isInIframe) {
          window.open('https://painel.calcariosrcal.com.br', '_blank')
        }

        this.$router.push({ name: 'Main' })
      } catch (error) {
        console.error(error)
        this.$q.notify({
          color: 'red',
          position: 'top-right',
          icon: 'report_problem',
          message: error.message
        })
      } finally {
        this.loading = false
      }
    },

    isValidMail (val) {
      return val && val.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/im)
    }
  },
  computed: {
    usuarioLogado () {
      return this.$store.getters.getUsuario
    },

    message () {
      return this.$store.getters.getMessage
    },
    isInIframe () {
      return this.$store.getters.getInIframe
    },
    token () {
      return this.$store.getters.getToken
    }
  },
  validations: {
    auth: {
      email: {
        required,
        email
      },
      senha: {
        required
      }
    }
  }
}
</script>

<style scoped>
  .btn-success {
    background-color: #255d46 !important;
    border-color: #255d46 !important;
  }
</style>